import { Injectable } from '@angular/core';
import { PaymentSocketData } from '@shared/components/horizon-payment-getaway/models/horizon-payment-getaway.model';
import { Row } from '@shared/interfaces/CallLog';
import { TranslateService } from '@ngx-translate/core';
import { PaymentNotification } from '@shared/interfaces/PaymentNotifications';
import { CurrencyPipe } from '@angular/common';
@Injectable({
  providedIn: 'root',
})
export class PaymentNotificationsService {
  constructor(
    private readonly translate: TranslateService,
    private readonly currencyPipe: CurrencyPipe
  ) {}

  buildEditPaymentNotification(generalRowData: Row): PaymentSocketData {
    return {
      sessionId: generalRowData.payment?.value?.sessionId ?? '',
      transactionType: '',
      paymentStatus: generalRowData.payment?.value?.applicationStatus
        ? generalRowData.payment?.value?.applicationStatus === 'Applied'
          ? 'success'
          : 'error'
        : undefined,
      paymentDetails: {
        amount: generalRowData.payment?.value?.amount ?? 0,
        currency: generalRowData.payment?.value?.currency ?? 'GBP',
        AttemptCount: 0,
        SuccessCount: 0,
        FailureCount: 0,
        ErrorCount: 0,
      },
      errors: [
        generalRowData.payment?.value?.errorMessage ?? '',
        generalRowData.payment?.value?.genesysErrorMessage ?? '',
      ],
    };
  }

  public controlPaymentResponse(
    paymentData: PaymentSocketData,
    isReport: boolean
  ): PaymentNotification {
    return {
      status: paymentData.paymentStatus,
      message: this.getPaymentNotificationMessage[paymentData.paymentStatus](
        paymentData,
        isReport
      ),
    };
  }

  private getPaymentNotificationMessage = {
    success: (paymentData: PaymentSocketData, isReport: boolean) =>
      this.translate.instant(
        'call_log.call_log_report_view.notifications.success',
        {
          amount: this.currencyPipe.transform(
            isReport
              ? paymentData.paymentDetails.amount / 100
              : paymentData.paymentDetails.amount,
            paymentData.paymentDetails.currency
          ),
        }
      ),
    error: (paymentData: PaymentSocketData, isReport: boolean) =>
      this.translate.instant(
        'call_log.call_log_report_view.notifications.error',
        {
          amount: this.currencyPipe.transform(
            isReport
              ? paymentData.paymentDetails.amount / 100
              : paymentData.paymentDetails.amount,
            paymentData.paymentDetails.currency
          ),
        }
      ),
    warning: (paymentData: PaymentSocketData) =>
      this.translate.instant(
        'call_log.call_log_report_view.notifications.warning',
        {
          error: paymentData.errors ?? 'Payment error',
        }
      ),
    info: (paymentData: PaymentSocketData, isReport: boolean) =>
      this.translate.instant(
        'call_log.call_log_report_view.notifications.info',
        {
          paymentType: paymentData.transactionType,
          amount: this.currencyPipe.transform(
            isReport
              ? paymentData.paymentDetails.amount / 100
              : paymentData.paymentDetails.amount,
            paymentData.paymentDetails.currency
          ),
        }
      ),
  };
}
